import { render, staticRenderFns } from "./Order-dispenzation.vue?vue&type=template&id=0f059159&scoped=true"
import script from "./Order-dispenzation.js?vue&type=script&lang=js&external"
export * from "./Order-dispenzation.js?vue&type=script&lang=js&external"
import style0 from "./Order-dispenzation.vue?vue&type=style&index=0&id=0f059159&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f059159",
  null
  
)

export default component.exports